import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import * as API from "../../../api";
import * as CONST from "../../../Constants";
import { useStyles } from "../../../layout/Styles";
import FormPaper from "../../../layout/FormPaper";
import PromptButtons from "./PromptButtons";
import { PatientData } from "../../../Contexts";
import Flash from "../../../layout/Flash";

const propTypes = {
  cpr: PropTypes.object.isRequired,
  handleUpdated: PropTypes.func.isRequired,
  handlePatientConsented: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};
ConsentPrompt.prototype = propTypes;

export default function ConsentPrompt(props) {
  const styles = useStyles();
  const patient = useContext(PatientData);
  const [reminder_notification_type, setNotification] = useState("");
  const [reminder_notification_schedule, setSchedule] = useState("");
  const [showSchedulePrompt, setShowSchedulePrompt] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [showReminders, setShowReminders] = useState(false);
  const [flash, setFlash] = useState(null);

  const flashMessage = (msg) => {
    setFlash(msg);
    // setTimeout(() => {
    //   setFlash(null);
    // }, 9000);
  };

  async function handleConfirm() {
    return await API.updateToCpr({
      cpr_id: props.cpr.id,
      option_value: 1, //I am aware of this care plan requirement
    });
  }
  async function confirmWithNoConsent() {
    let res = await handleConfirm();
    if (res.error) {
      flashMessage({ error: res.error });
    } else {
      flashMessage({
        success:
          "Appointment Confirmed! If you would like to consent later, navigate to your account settings by clicking on edit account. Please complete your care plan requirement to ensure you earn the maximum incentive from your health plan.",
      });
      props.dispatch(res.data.cpr);
    }
  }

  async function submitPatientConsent() {
    let consented = await API.postToPatientSettings({ patient_consented_to_notifications: "true" });
    if (consented.error) {
      props.flash({ error: consented.error });
    } else {
      flashMessage({
        success: "Success! Thank you for consenting to direct messaging from Your wellPORTAL",
      });
    }
  }
  async function submitPatientPhone(req) {
    let res = await API.postToPatientSettings({ phone: req });
    console.log("submitPatientPhone[API]:res", res);
    if (res.error) {
      flashMessage({
        error: "There was an error submitting your request. Try again later.",
      });
    } else {
      setSubmitted(true);
      setShowSchedulePrompt(true);
      flashMessage({
        success: "Success! Your number has been saved",
      });
    }
  }

  async function submitNotification(req) {
    await API.updateToCpr({
      cpr: {
        id: props.cpr.id,
        ...req,
      },
    });
    let res = await handleConfirm();
    props.dispatch(res.data.cpr);
    props.handlePatientConsented(true);
    props.handleFlash({
      success:
        "Appointment Confirmed! We’ll send you a reminder notification 15 days before it’s due.  We’ll also send you direct text/email reminders if you requested them.",
    });
    props.handleUpdated();
    console.log("ConsentPrompt[API.postToCpr]", res);
  }

  const ScheduleReminders = () => {
    const [phone, setPhone] = useState(null);

    return (
      <>
        {!reminder_notification_type && !showSchedulePrompt && (
          <>
            <Typography variant="h5" color="#1a247e" fontWeight="600">
              {CONST.REMINDER_NOTIFICATION_CONSENT.prompt}
            </Typography>
            <Box ml={1}>
              <RadioGroup aria-labelledby="" defaultValue="" name="radio-buttons-group">
                {CONST.REMINDER_NOTIFICATION_CONSENT.options.map((o, i) => (
                  <FormControlLabel
                    value={o.value}
                    key={i}
                    onSelect={(e) => {
                      setNotification(o.value);
                    }}
                    control={
                      <Radio
                        onClick={(e) => {
                          setShowSchedulePrompt(true);
                          setNotification(o.value);
                        }}
                        sx={{
                          "& .MuiSvgIcon-root": {
                            fontSize: 25,
                          },
                        }}
                      />
                    }
                    label={
                      <Box ml={2} sx={{ textTransform: "none", fontSize: "17px" }}>
                        {o.text}
                      </Box>
                    }
                  />
                ))}
              </RadioGroup>
            </Box>
          </>
        )}
        {showSchedulePrompt &&
          !patient.phone &&
          !submitted &&
          reminder_notification_type !== "email" && (
            <Box mt={1} mb={2}>
              <Typography variant="h5" color="#1a247e">
                <b>{CONST.NO_PHONE_PROMPT.prompt}</b>
                {CONST.NO_PHONE_PROMPT.subText && CONST.NO_PHONE_PROMPT.subText}
              </Typography>
              <Box mt={2}>
                <input
                  placeholder="mobile number"
                  className={styles.field}
                  onChange={(e) => {
                    setPhone(e.target.value);
                  }}
                />
                <Box mt={4}>
                  <button
                    className="prompt confirm"
                    onClick={(e) => {
                      e.preventDefault();
                      submitPatientPhone(phone);
                    }}
                  >
                    {"Submit"}
                  </button>
                </Box>
              </Box>
            </Box>
          )}

        {showSchedulePrompt && (submitted || reminder_notification_type == "email") && (
          <FormControl>
            <Box mt={1} mb={1}>
              <Typography variant="h5 " color="#1a247e" fontWeight="600">
                {CONST.REMINDER_SCHEDULE_PROMPT.prompt}
              </Typography>
              <Box pt={1} pb={1}>
                {CONST.REMINDER_SCHEDULE_PROMPT.subText && CONST.REMINDER_SCHEDULE_PROMPT.subText}
              </Box>
              <RadioGroup aria-labelledby="" defaultValue="" name="radio-buttons-group">
                <Box ml={2}>
                  {CONST.REMINDER_SCHEDULE_PROMPT.options.map((o, i) => (
                    <FormControlLabel
                      value={o.value}
                      key={i}
                      control={
                        <Radio
                          onClick={(e) => {
                            console.log(reminder_notification_schedule, reminder_notification_type);
                            setSchedule(o.value);
                          }}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: 25,
                            },
                          }}
                        />
                      }
                      label={
                        <Box ml={2} sx={{ textTransform: "none", fontSize: "17px" }}>
                          {o.text}
                        </Box>
                      }
                    />
                  ))}
                </Box>
              </RadioGroup>
              <Box mt={4}>
                <button
                  className="prompt confirm"
                  onClick={(e) => {
                    e.preventDefault();
                    console.log(reminder_notification_schedule, reminder_notification_type);
                    submitNotification({
                      reminder_notification_type: reminder_notification_type,
                      reminder_notification_schedule: reminder_notification_schedule,
                    });
                  }}
                >
                  {"Submit"}
                </button>
              </Box>
            </Box>
          </FormControl>
        )}
      </>
    );
  };

  return (
    <>
      {flash && <Flash flash={flash} handleClose={(e) => setFlash(null)} />}

      <FormPaper>
        {!showReminders && (
          <>
            <Typography variant="h5" color="#1a247e" fontWeight="600">
              {CONST.CONSENT_TEXT}
              <br />
              <br />
              {
                "Do you agree to our direct text and/or email messaging terms and conditions? Click "
              }
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.yourwellportal.com/consent-notice"
              >
                here
              </a>
              {" for more details"}
              <br />
              <br />
            </Typography>
            <PromptButtons
              buttons={{
                yesText: "Yes",
                noText: "No",
                onSelect: (val) => {
                  if (val == "yes") {
                    submitPatientConsent();
                    setShowReminders(true);
                  } else {
                    confirmWithNoConsent();
                  }
                },
              }}
            />
          </>
        )}
        {showReminders && <ScheduleReminders />}
      </FormPaper>
    </>
  );
}
